module.exports = __webpack_public_path__ + "static/img/7.00d2060.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/7.png
// module id = bOao
// module chunks = 0